export default __webpack_public_path__ + "static/media/hist.7bbe1c04.png";